import __request__ from "routing/request";
export function list() {
  return __request__("GET", "/system/cluster_config", null, {}, {
    "Accept": ["application/json"]
  });
}
export function schema(configClass) {
  return __request__("GET", `/system/cluster_config/${configClass}`, null, {}, {
    "Accept": ["application/schema+json"]
  });
}
export function update(configClass, body) {
  return __request__("PUT", `/system/cluster_config/${configClass}`, body, {}, {
    "Accept": ["application/json"]
  });
}
export function read(configClass) {
  return __request__("GET", `/system/cluster_config/${configClass}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(configClass) {
  return __request__("DELETE", `/system/cluster_config/${configClass}`, null, {}, {
    "Accept": ["application/json"]
  });
}
